import {
  Card,
  CardContent,
  FormControlLabel,
  Grid,
  Switch,
} from "@mui/material";

import { TrueffortTextField } from "../../MUIstyle/MUICustom";
import { styleReactSelect } from "../../MUIstyle/GlobalStyles";
import Select from "react-select";
import { useTranslation } from "react-i18next";

export default function RelatedStatus({
  statusTool,
  setRelations,
  relations,
  api,
  managedState,
  setManagedState,
}: {
  statusTool: any;
  setRelations: any;
  relations: any;
  api: string;
  managedState: boolean;
  setManagedState: any;
}) {
  const { t } = useTranslation();

  const getStatusKey = (status: any) => {
    return String(status?.id ?? status?.value ?? status?.name ?? status);
  };

  const normalizeStatusOption = (status: any) => {
    return {
      id: status.id,
      name: status.name,
      value: status.id,
      label: status.name,
    };
  };

  const getAvailableStatusesForRelation = (currentRelation: any) => {
    const currentSelectedKeys = new Set(
      (currentRelation.statusTool || []).map((status: any) =>
        getStatusKey(status),
      ),
    );

    const selectedInOtherRelations = new Set(
      relations
        .filter(
          (relation: any) => String(relation.id) !== String(currentRelation.id),
        )
        .flatMap((relation: any) => relation.statusTool || [])
        .map((status: any) => getStatusKey(status)),
    );

    return statusTool
      .map((status: any) => normalizeStatusOption(status))
      .filter((status: any) => {
        const key = getStatusKey(status);

        return currentSelectedKeys.has(key) || !selectedInOtherRelations.has(key);
      });
  };

  return (
    <>
      {relations.length > 0 && (
        <Card elevation={2} sx={{ overflow: "unset", height: "100%" }}>
          <CardContent>
            <span>{t("Herramienta.related_status").replace("{0}", api)}</span>

            <Grid style={{ paddingTop: "1em" }} container spacing={1}>
              <Grid item sm={4} xs={6}>
                {"Estado Trueffort"}
              </Grid>

              <Grid item sm={8} xs={6}>
                {"Estados " + api}
              </Grid>

              {relations.map((ua: any, ind: number) => (
                <>
                  <Grid item sm={4} xs={6}>
                    <TrueffortTextField
                      disabled
                      value={ua.name}
                      fullWidth
                      size="small"
                    />
                  </Grid>

                  <Grid item sm={8} xs={6}>
                    <Select
                      id="sel_status"
                      name="status"
                      value={ua.statusTool}
                      options={getAvailableStatusesForRelation(ua)}
                      onChange={(option: any) => {
                        const relationsAux = [...relations];
                        relationsAux[ind] = {
                          ...relationsAux[ind],
                          statusTool: option || [],
                        };

                        setRelations(relationsAux);
                      }}
                      styles={styleReactSelect}
                      isMulti
                    />
                  </Grid>

                  {ua.errors !== "" && (
                    <Grid item sm={12}>
                      <span className="text-danger">{ua.error}</span>
                    </Grid>
                  )}
                </>
              ))}
            </Grid>

            <FormControlLabel
              control={
                <Switch
                  checked={managedState}
                  onChange={(ev: any) => setManagedState(ev.target.checked)}
                />
              }
              label={"Gestionar estados desde Trueffort"}
            />
          </CardContent>
        </Card>
      )}
    </>
  );
}